import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { buildMinuteOptions, snapToNearest } from './minutes-picker.helpers';

@Component({
  selector: 'minutes-picker',
  templateUrl: './minutes-picker.component.html',
  styleUrls: ['./minutes-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinutesPickerComponent implements OnChanges {
  @ViewChild(IonModal) modal!: IonModal;

  @Input() title = '';
  @Input() value = 0;
  @Input() min = 1;
  @Input() max = 95;
  @Input() disabled = false;
  @Input() border = false;
  @Input() compact = false;

  @Output() onValueSelected = new EventEmitter<number>();

  public options: number[] = [];
  public display = 0;  // snapped current value shown on the panel
  public selected = 0; // wheel selection inside the modal

  public ngOnChanges(): void {
    this.options = buildMinuteOptions(this.max, { min: this.min });
    this.display = snapToNearest(this.value, this.options);
    this.selected = this.display;
  }

  public onColumnChange(event: CustomEvent): void {
    this.selected = Number(event.detail.value);
  }

  public open(): void {
    if (!this.disabled) {
      this.modal.present();
    }
  }

  public onApply(): void {
    this.onValueSelected.emit(this.selected);
    this.modal.dismiss();
  }

  public label(n: number): string {
    return `${n} ${n === 1 ? 'minute' : 'minutes'}`;
  }
}
